"use client"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import SelectPlacement from "./SelectPlacement"
import { faPaperPlane } from "@fortawesome/free-regular-svg-icons"
import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks"
import { tourActions } from "@/lib/redux/features/tour/reduce"
import { useTranslation } from "react-i18next"

let timeoutSearch: any = null

const SelectDeparture = () => {
  const dispatch = useAppDispatch()
  const departure = useAppSelector(state => state.tour.formSearch.departure)
  const { t } = useTranslation()

  return (
    <SelectPlacement
      type='departure'
      icon={<FontAwesomeIcon icon={faPaperPlane} />}
      label={t("flight.departure_from")}
      placeholder={t("tour.departure_from_label")}
      popoverProps={{
        styles: {
          content: {
            width: 'auto'
          }
        }
      }}
      onSearch={(val) => {
        if (timeoutSearch) {
          clearTimeout(timeoutSearch)
        }
        timeoutSearch = setTimeout(() => {
          dispatch(tourActions.searchDestinations(val))
        }, 500)

      }}
      onChange={(valueObject) => {
        dispatch(tourActions.selectDeparture(valueObject))
      }}
      value={departure}
    />
  )
}

export default SelectDeparture